// extracted by mini-css-extract-plugin
export var hidden = "_6o-1";
export var leftPanel = "_6o-2";
export var readonlyInspector = "_6o-3";
export var rightPanel = "_6o-0";